// extracted by mini-css-extract-plugin
module.exports = {"playbookPriorityTable":"styles_playbookPriorityTable__1i8FK"};